export const getProductLists = state => {
  return state.result.list
}

export const getProductsResult = state => {
  return state.result
}

export const getProductDetail = state => {
  return state.detail
}

export const getSearch = state => {
  return state.search
}

export const getSelectedQuantity = state => {
  return state.selectedQuantity
}



// WEBPACK FOOTER //
// ./src/store/modules/products/getters.js